// StateAwards.js
import './css/mycss.css'
import { Cards } from './Cards.js'

import img1 from './images/st1.png';import img15 from './images/st15.png';
import img2 from './images/st2.png';import img16 from './images/st16.png';
import img3 from './images/st3.png';import img17 from './images/st17.png';
import img4 from './images/st4.png';import img18 from './images/st18.png';
import img5 from './images/st5.png';import img19 from './images/st19.png';
import img6 from './images/st6.png';import img20 from './images/st20.png';
import img7 from './images/st7.png';import img21 from './images/st21.png';
import img8 from './images/st8.png';import img22 from './images/st22.png';
import img9 from './images/st9.png';import img23 from './images/st23.png';
import img10 from './images/st10.png';import img24 from './images/st24.png';
import img11 from './images/st11.png';import img25 from './images/st25.png';
import img12 from './images/st12.png';import img26 from './images/st26.png';
import img13 from './images/st13.png';import img27 from './images/st27.png';
import img14 from './images/st14.png';import img28 from './images/st28.png';

/* ----------------- Export Data For Global Search ----------------- */

export const stateAwardsData = [

  {category:"State",htext:"Andhra Pradesh Gaurava Puraskaram",ptext:"Andhra Pradesh",img1,ialt:"AP Gaurava Puraskaram",
    modalContent:`
    <b>Established:</b>2021</br>
<b>Type:</b>State Civilian Award</br>
<b>First Awarded:</b>2021</br>
<b>First Recipient:</b>Multiple awardees</br>
<b>Symbolism:</b>Honors excellence in public life and service benefiting Andhra Pradesh.</br>
<b>Awarded For:</b>Arts, culture, literature, agriculture and social service.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Andhra_Pradesh'>wiki link</a></b>
    `},
  {category:"State",htext:"Arunachal Ratna",ptext:"Arunachal Pradesh",img1:img2,ialt:"Arunachal Ratna",
    modalContent:`
    <b>Established:</b>2021</br>
<b>Type:</b>State Civilian Award</br>
<b>First Awarded:</b>2021</br>
<b>First Recipient:</b>Former CM Dorjee Khandu (posthumous)</br>
<b>Symbolism:</b>Represents exceptional distinction and service to the state.</br>
<b>Awarded For:</b>Public service, culture, governance and development.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Arunachal_Ratna'>wiki link</a></b> 
    `},
  {category:"State",htext:"Asom Ratna",ptext:"Assam",img1:img3,ialt:"Asom Ratna",
    modalContent:`
    <b>Name:</b> Asom Ratna
<b>Short Description:</b> Highest civilian award of Assam.
<b>Established:</b> 2008
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2009
<b>First Recipient:</b> Bhupen Hazarika
<b>Symbolism:</b> Signifies Assam’s respect for cultural and social excellence.
<b>Awarded For:</b> Exceptional contribution to Assamese culture and public life.
              <br/><b><a href='https://en.wikipedia.org/wiki/Asom_Ratna'>wiki link</a></b> 
    `},
  {category:"State",htext:"Bihar Vishesh Samman",ptext:"Bihar",img1:img4,ialt:"Bihar Vishesh Samman",
    modalContent:`
    <b>Name:</b> Bihar Vishesh Samman
<b>Short Description:</b> Prestigious state award recognizing outstanding contributions.
<b>Established:</b> 2019
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2019
<b>First Recipient:</b> Multiple eminent personalities
<b>Symbolism:</b> Represents honor, dedication and cultural pride of Bihar.
<b>Awarded For:</b> Arts, literature, social work and public service.
              <br/><b><a href='https://en.wikipedia.org/wiki/Bihar_Vishesh_Samman'>wiki link</a></b> 
    `},
  {category:"State",htext:"Minimata Alankaran",ptext:"Chhattisgarh",img1:img5,ialt:"Chhattisgarh Alankaran",
    modalContent:`
    <b>Name:</b> Minimata Alankaran
<b>Short Description:</b> One of Chhattisgarh’s highest honors for social and public service.
<b>Established:</b> 2001
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2002
<b>First Recipient:</b> Multiple recipients
<b>Symbolism:</b> Represents empowerment and service to society.
<b>Awarded For:</b> Social service, women’s empowerment and public contribution.
              <br/><b><a href='https://en.wikipedia.org/wiki/Minimata_Alankaran'>wiki link</a></b> 
    `},
  {category:"State",htext:"Gomant Vibhushan",ptext:"Goa",img1:img6,ialt:"Gomant Vibhushan",
    modalContent:`
    <b>Name:</b> Gomant Vibhushan Award
<b>Short Description:</b> Highest civilian honor of Goa.
<b>Established:</b> 2008
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2009
<b>First Recipient:</b> Prof. Anvita Abbi
<b>Symbolism:</b> Signifies cultural and intellectual excellence.
<b>Awarded For:</b> Exceptional contributions to Goa’s development and heritage.
              <br/><b><a href='https://en.wikipedia.org/wiki/Gomant_Vibhushan_Award'>wiki link</a></b>
    `},
  {category:"State",htext:"Gujarat Gaurav Puraskar",ptext:"Gujarat",img1:img7,ialt:"Gujarat Puraskar",
    modalContent:`
    <b>Name:</b> Gujarat Gaurav Puraskar
<b>Short Description:</b> Top state honor for cultural and literary excellence.
<b>Established:</b> 1983
<b>Type:</b> State Cultural Award
<b>First Awarded:</b> 1983
<b>First Recipient:</b> Multiple literary contributors
<b>Symbolism:</b> Emphasizes pride in Gujarat’s heritage.
<b>Awarded For:</b> Literature, arts and cultural service.
              <br/><b><a href='https://en.wikipedia.org/wiki/Yuva_Gaurav_Puraskar'>wiki link</a></b> 
    `},
  {category:"State",htext:"Bhim Award",ptext:"Haryana",img1:img8,ialt:"Bhim Award",
    modalContent:`
    <b>Name:</b> Bhim Award
<b>Short Description:</b> Haryana’s highest sports honor.
<b>Established:</b> 2001
<b>Type:</b> State Sports Award
<b>First Awarded:</b> 2002
<b>First Recipient:</b> Various sportspersons
<b>Symbolism:</b> Represents strength, excellence and sporting pride.
<b>Awarded For:</b> Outstanding achievements in sports.
              <br/><b><a href='https://haryanasports.gov.in/award/bhim-award/'>wiki link</a></b> 
    `},
  {category:"State",htext:"Himachal Gaurav Award",ptext:"Himachal",img1:img9,ialt:"Himachal Gaurav",
    modalContent:`
    <b>Name:</b> Himachal Gaurav Award
<b>Short Description:</b> Prestigious civilian award of Himachal Pradesh.
<b>Established:</b> 1990
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 1990
<b>First Recipient:</b> Multiple recipients
<b>Symbolism:</b> Celebrates service to the people of Himachal.
<b>Awarded For:</b> Social service, arts, culture and public excellence.
              <br/><b><a href='https://en.wikipedia.org/wiki/Himachal_Gaurav_Award'>wiki link</a></b> 
    `},
  {category:"State",htext:"Jharkhand Ratna",ptext:"Jharkhand",img1:img10,ialt:"Jharkhand Ratna",
    modalContent:`
    <b>Name:</b> Jharkhand Ratna
<b>Short Description:</b> Highest state honor recognizing distinguished achievements.
<b>Established:</b> 2000
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2000
<b>First Recipient:</b> Legendary contributors from Jharkhand
<b>Symbolism:</b> Reflects pride in tribal, cultural and social heritage.
<b>Awarded For:</b> Arts, literature, social service and cultural preservation.
              <br/><b><a href='https://en.wikipedia.org/wiki/Jharkhand_Ratna'>wiki link</a></b> 
    `},
  {category:"State",htext:"Karnataka Ratna",ptext:"Karnataka",img1:img11,ialt:"Karnataka Ratna",
    modalContent:`
    <b>Name:</b> Karnataka Ratna
<b>Short Description:</b> Highest civilian award of Karnataka.
<b>Established:</b> 1992
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 1992
<b>First Recipient:</b> Dr. Rajkumar
<b>Symbolism:</b> Represents Karnataka’s cultural glory.
<b>Awarded For:</b> Exceptional contributions in any field.
              <br/><b><a href='https://en.wikipedia.org/wiki/Karnataka_Ratna'>wiki link</a></b> 
    `},
  {category:"State",htext:"Kerala Jyothi",ptext:"Kerala",img1:img12,ialt:"Kerala Jyothi",
    modalContent:`
    <b>Name:</b> Kerala Jyothi
<b>Short Description:</b> Highest civilian honor under Kerala’s new award system.
<b>Established:</b> 2021
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2022
<b>First Recipient:</b> O. N. V. Kurup (posthumously)
<b>Symbolism:</b> Symbolizes enlightenment and cultural excellence.
<b>Awarded For:</b> Arts, literature, science and social advancement.
              <br/><b><a href='https://en.wikipedia.org/wiki/Kerala_Jyothi'>wiki link</a></b>
    `},
  {category:"State",htext:"Rashtriya Lata Mangeshkar Award",ptext:"Madhya Pradesh",img1:img13,ialt:"MP Lata Award",
    modalContent:`
    <b>Name:</b> Lata Mangeshkar Award
<b>Short Description:</b> Highest cultural honor of Madhya Pradesh.
<b>Established:</b> 1984
<b>Type:</b> State Cultural Award
<b>First Awarded:</b> 1984
<b>First Recipient:</b> Naushad Ali
<b>Symbolism:</b> Represents artistic excellence.
<b>Awarded For:</b> Contributions to music and the arts.
              <br/><b><a href='https://en.wikipedia.org/wiki/Lata_Mangeshkar_Award'>wiki link</a></b>
    `},
  {category:"State",htext:"Maharashtra Bhushan",ptext:"Maharashtra",img1:img14,ialt:"Maharashtra Bhushan",
    modalContent:`
    <b>Name:</b> Maharashtra Bhushan
<b>Short Description:</b> Highest civilian honor of Maharashtra.
<b>Established:</b> 1996
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 1996
<b>First Recipient:</b> P. L. Deshpande
<b>Symbolism:</b> Represents excellence in public life and culture.
<b>Awarded For:</b> Arts, literature, social work and public service.
              <br/><b><a href='https://en.wikipedia.org/wiki/Maharashtra_Bhushan'>wiki link</a></b> 
    `},
  {category:"State",htext:"Manipur State Literature Award",ptext:"Manipur",img1:img15,ialt:"Manipur Award",
    modalContent:`
    <b>Name:</b> Manipur State Award for Literature
<b>Short Description:</b> Highest literary honor of Manipur.
<b>Established:</b> 1992
<b>Type:</b> State Literary Award
<b>First Awarded:</b> 1993
<b>First Recipient:</b> Khaidem Pramodini
<b>Symbolism:</b> Celebrates the richness of Manipuri literature.
<b>Awarded For:</b> Outstanding literary contributions.
              <br/><b><a href='https://dlpi.mn.gov.in/en/manipur-state-award-literature/'>wiki link</a></b>
    `},
  {category:"State",htext:"Meghalaya Day Award",ptext:"Meghalaya",img1:img16,ialt:"Meghalaya Award",
    modalContent:`
    <b>Name:</b> Meghalaya Day Excellence Award
<b>Short Description:</b> Highest state award presented annually on Meghalaya Day.
<b>Established:</b> 2012
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2012
<b>First Recipient:</b> Multiple recipients
<b>Symbolism:</b> Reflects dedication to the state’s culture and development.
<b>Awarded For:</b> Service in public life, arts, social service.
              <br/><b><a href='https://en.wikipedia.org/wiki/Meghalaya_Day_Award'>wiki link</a></b>
    `},
  {category:"State",htext:"Thenzawl Cultural Award",ptext:"Mizoram",img1:img17,ialt:"Thenzawl",
    modalContent:`
    <b>Name:</b> Thenzawl Award
<b>Short Description:</b> Major cultural honor of Mizoram.
<b>Established:</b> 2005
<b>Type:</b> State Cultural Award
<b>First Awarded:</b> 2005
<b>First Recipient:</b> Multiple artists
<b>Symbolism:</b> Represents Mizo cultural preservation.
<b>Awarded For:</b> Arts, culture and heritage.
              <br/><b><a href='https://en.wikipedia.org/wiki/Thenzawl'>wiki link</a></b> 
    `},
  {category:"State",htext:"Governor’s Award for Excellence",ptext:"Nagaland",img1:img18,ialt:"Nagaland Award",
    modalContent:`
    <b>Name:</b> Governor’s Award for Excellence
<b>Short Description:</b> Prestigious state award recognizing extraordinary contributions.
<b>Established:</b> 2004
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2004
<b>First Recipient:</b> Multiple contributors
<b>Symbolism:</b> Symbolizes honor and service to Nagaland.
<b>Awarded For:</b> Arts, culture, social service and innovation.
              <br/><b><a href='https://en.wikipedia.org/wiki/Governors_Awards'>wiki link</a></b> 
    `},
  {category:"State",htext:"Odisha State Honour",ptext:"Odisha",img1:img19,ialt:"Odisha Honour",
    modalContent:`
    <b>Name:</b> Odisha State Honour Award
<b>Short Description:</b> Top award recognizing excellence in arts and culture.
<b>Established:</b> 1999
<b>Type:</b> State Cultural Award
<b>First Awarded:</b> 1999
<b>First Recipient:</b> Multiple artists
<b>Symbolism:</b> Celebrates Odia heritage and cultural pride.
<b>Awarded For:</b> Literature, arts and cultural preservation.
              <br/><b><a href='https://en.wikipedia.org/wiki/Odisha_State_Honour_Award'>wiki link</a></b> 
    `},
  {category:"State",htext:"Maharaja Ranjit Singh Award",ptext:"Punjab",img1:img20,ialt:"Punjab Award",
    modalContent:`
    <b>Name:</b> Maharaja Ranjit Singh Award
<b>Short Description:</b> Highest sports honor of Punjab.
<b>Established:</b> 1978
<b>Type:</b> State Sports Award
<b>First Awarded:</b> 1978
<b>First Recipient:</b> Outstanding sportspersons
<b>Symbolism:</b> Represents bravery, excellence and discipline.
<b>Awarded For:</b> Excellence in sports.
              <br/><b><a href='https://en.wikipedia.org/wiki/Maharaja_Ranjit_Singh_Award'>wiki link</a></b> 
    `},
  {category:"State",htext:"Rajasthan Ratna",ptext:"Rajasthan",img1:img21,ialt:"Rajasthan Ratna",
    modalContent:`
    <b>Name:</b> Rajasthan Ratna
<b>Short Description:</b> Highest civilian honor of Rajasthan.
<b>Established:</b> 2012
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2012
<b>First Recipient:</b> Seven eminent personalities
<b>Symbolism:</b> Symbolizes Rajasthan’s cultural and social pride.
<b>Awarded For:</b> Outstanding service in arts, culture and society. 
              <br/><b><a href='https://en.wikipedia.org/wiki/Rajasthan_Ratna'>wiki link</a></b> 
    `},
  {category:"State",htext:"Sikkim Sewa Samman",ptext:"Sikkim",img1:img22,ialt:"Sikkim Samman",
    modalContent:`
    <b>Name:</b> Sikkim Sewa Samman
<b>Short Description:</b> Leading state award honoring community service.
<b>Established:</b> 2004
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2004
<b>First Recipient:</b> Multiple personalities
<b>Symbolism:</b> Represents dedication to Sikkim’s welfare.
<b>Awarded For:</b> Social service and community upliftment.
              <br/><b><a href='https://en.wikipedia.org/wiki/Sikkim_Sewa_Samman'>wiki link</a></b> 
    `},
  {category:"State",htext:"Kalaimamani Award",ptext:"Tamil Nadu",img1:img23,ialt:"Kalaimamani",
    modalContent:`
    <b>Name:</b> Kalaimamani Award
<b>Short Description:</b> Highest arts and culture honor of Tamil Nadu.
<b>Established:</b> 1954
<b>Type:</b> State Cultural Award
<b>First Awarded:</b> 1954
<b>First Recipient:</b> Multiple artists
<b>Symbolism:</b> Signifies artistic excellence.
<b>Awarded For:</b> Music, dance, drama, film and literature.
              <br/><b><a href='https://en.wikipedia.org/wiki/Kalaimamani_Award'>wiki link</a></b> 
    `},
  {category:"State",htext:"Telangana Excellence Award",ptext:"Telangana",img1:img24,ialt:"Telangana Award",
    modalContent:`
    <b>Name:</b> Telangana Excellence Award
<b>Short Description:</b> Award recognizing innovation and public service in Telangana.
<b>Established:</b> 2017
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2017
<b>First Recipient:</b> Multiple recipients
<b>Symbolism:</b> Represents progress and modern governance.
<b>Awarded For:</b> Public service, innovation and policy impact.
              <br/><b><a href='https://en.wikipedia.org/wiki/Telangana_Excellence_Award'>wiki link</a></b>
    `},
  {category:"State",htext:"Tripura State Literary Award",ptext:"Tripura",img1:img25,ialt:"Tripura Award",
    modalContent:`
    <b>Name:</b> Tripura State Literary Award
<b>Short Description:</b> Leading award for literary excellence in Tripura.
<b>Established:</b> 1987
<b>Type:</b> State Literary Award
<b>First Awarded:</b> 1987
<b>First Recipient:</b> Noted Tripuri writers
<b>Symbolism:</b> Represents commitment to literary culture.
<b>Awarded For:</b> Contributions to Bengali and Kokborok literature.
              <br/><b><a href='https://en.wikipedia.org/wiki/Tripura_State_Literary_Award'>wiki link</a></b> 
    `},
  {category:"State",htext:"Uttar Pradesh Ratna",ptext:"Uttar Pradesh",img1:img26,ialt:"UP Ratna",
    modalContent:`
    <b>Name:</b> Uttar Pradesh Ratna
<b>Short Description:</b> Prestigious award for individuals contributing globally to UP’s heritage.
<b>Established:</b> 2015
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2015
<b>First Recipient:</b> Frank Islam
<b>Symbolism:</b> Highlights global excellence from UP natives.
<b>Awarded For:</b> International cultural, social and economic contributions.
              <br/><b><a href='https://en.wikipedia.org/wiki/Uttar_Pradesh_Ratna'>wiki link</a></b> 
    `},
  {category:"State",htext:"Uttarakhand Ratna",ptext:"Uttarakhand",img1:img27,ialt:"UK Ratna",
    modalContent:`
    <b>Name:</b> Uttarakhand Ratna
<b>Short Description:</b> Highest civilian honor of Uttarakhand.
<b>Established:</b> 2016
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2016
<b>First Recipient:</b> Narayan Dutt Tiwari, Bachendri Pal and others
<b>Symbolism:</b> Signifies service, courage and pride.
<b>Awarded For:</b> Arts, public service, science and social work.
              <br/><b><a href='https://en.wikipedia.org/wiki/Uttarakhand_Ratna'>wiki link</a></b> 
    `},
  {category:"State",htext:"Banga Bibhushan",ptext:"West Bengal",img1:img28,ialt:"Banga Bibhushan",
    modalContent:`
    <b>Name:</b> Banga Bibhushan
<b>Short Description:</b> Highest civilian honor of West Bengal.
<b>Established:</b> 2011
<b>Type:</b> State Civilian Award
<b>First Awarded:</b> 2011
<b>First Recipient:</b> Manna Dey
<b>Symbolism:</b> Celebrates Bengal’s cultural and intellectual heritage.
<b>Awarded For:</b> Arts, culture, literature and social contribution.
              <br/><b><a href='https://en.wikipedia.org/wiki/Banga_Bibhushan'>wiki link</a></b> 
    `}
]

/* ----------------- Page Component ----------------- */

export default function StateAwards() {
  return (
    <div>
      <h1 className="heading">State Awards</h1>
      <h3 className="head2">Honouring remarkable talent and contribution.</h3>

      <div className="search-cards-container">
        {stateAwardsData.map((award,i)=>(
          <Cards key={i} htext={award.htext} ptext={award.ptext} img1={award.img1} ialt={award.ialt} btext="learn more" modalContent={award.modalContent}/>
        ))}
      </div>
    </div>
  )
}
